import type { EventPayload } from '@side/analytics';

export enum TrackAppRefreshModalEvent {
  MountModal,
  ClickSnoozeButton,
  ClickRefreshButton,
}

type EventTypeLabels = Record<TrackAppRefreshModalEvent, string>;

export const AppRefreshEventLabels: EventTypeLabels = {
  [TrackAppRefreshModalEvent.MountModal]: 'APP_REFRESH_MODAL',
  [TrackAppRefreshModalEvent.ClickSnoozeButton]: 'APP_REFRESH_MODAL',
  [TrackAppRefreshModalEvent.ClickRefreshButton]: 'APP_REFRESH_MODAL',
};

type EventTypePayloads = Record<TrackAppRefreshModalEvent, EventPayload>;

export const AppRefreshEventsMap: EventTypePayloads = {
  [TrackAppRefreshModalEvent.MountModal]: {
    eventContainer: 'app_version_refresh_modal',
    eventTarget: 'app_version_refresh_modal',
    eventType: 'load',
    task: 'view',
  },
  [TrackAppRefreshModalEvent.ClickSnoozeButton]: {
    eventContainer: 'app_version_refresh_modal',
    eventTarget: 'snooze_button',
    eventType: 'click',
    task: 'select',
  },
  [TrackAppRefreshModalEvent.ClickRefreshButton]: {
    eventContainer: 'app_version_refresh_modal',
    eventTarget: 'refresh_button',
    eventType: 'click',
    task: 'select',
  },
};
